import React, {FC, useEffect} from 'react';

import AemButton from '@/components/Aem/AemButton';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {useJourneyLevelAction} from '@/hooks/loyalty/dataHooks';
import appContent from '@/services/content/appContent';
import {getAchievedBadgeImage} from '@/services/loyalty/badgeUtils';
import {LoyaltyActionInfoType} from '@/types/loyalty';
import {twx} from '@/utils/tailwindUtils';
import {LoyaltyPopupTemplate} from '@/views/Loyalty/PopupTemplates/primitives';

interface ICompleteTaskPopupTemplateProps {
    className?: string;
    buttonClassName?: string;
    onClose?: () => void;
    onGotIt?: () => void;
    actionInfo?: LoyaltyActionInfoType;
}

export const CompleteTaskPopupTemplate: FC<ICompleteTaskPopupTemplateProps> = ({
    onClose,
    onGotIt,
    className,
    buttonClassName,
    actionInfo,
}) => {
    const action = useJourneyLevelAction(actionInfo);
    const {primaryButton, icon} = appContent.getCompleteTaskContent() || {};
    const {journeyBadge, actionDescription, actionLabel} = action || {};
    const {alt} = primaryButton || {};

    useEffect(() => {
        if (!action) {
            onClose?.();
        }
    }, []);

    if (!action) {
        return null;
    }

    return (
        <LoyaltyPopupTemplate className={className}>
            <LoyaltyPopupTemplate.Header handleClose={onClose} />
            <LoyaltyPopupTemplate.Body>
                <LoyaltyPopupTemplate.Hero imageSrc={getAchievedBadgeImage(journeyBadge)?.imageURL}>
                    <LoyaltyPopupTemplate.Title className='mt-2.5'>
                        {journeyBadge.journeyName}
                    </LoyaltyPopupTemplate.Title>
                </LoyaltyPopupTemplate.Hero>
                <LoyaltyPopupTemplate.Footer>
                    <div className='pr-5 text-16 font-normal'>
                        <p className='text-tertiary'>{actionLabel}</p>
                        <p className='text-white'>{actionDescription}</p>
                    </div>
                    <div className='flex shrink-0 items-center justify-center'>
                        {/* @ts-ignore*/}
                        <RemoteIconV2 icon={icon} />
                    </div>
                </LoyaltyPopupTemplate.Footer>
                <AemButton
                    aria-label={alt}
                    primary
                    dark
                    className={twx('m-0 w-full px-6 py-3', buttonClassName)}
                    {...primaryButton}
                    onClick={onGotIt}
                />
            </LoyaltyPopupTemplate.Body>
        </LoyaltyPopupTemplate>
    );
};
